(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}



function $c50969dc1df61e8b$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(arr);
}


function $09c9f293d010c0e1$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $38c2d4931cb7a7c4$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $227c6742e0ff6f82$export$71511d61b312f219(arr) {
    return (0, $c50969dc1df61e8b$export$71511d61b312f219)(arr) || (0, $09c9f293d010c0e1$export$71511d61b312f219)(arr) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr) || (0, $38c2d4931cb7a7c4$export$71511d61b312f219)();
}


var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        this.size = 4;
        this.board = initialState ? this.clone(initialState) : this.createEmptyBoard();
        this.score = 0;
        this.status = "idle";
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "createEmptyBoard",
            value: function createEmptyBoard() {
                var _this = this;
                return Array.from({
                    length: this.size
                }, function() {
                    return Array(_this.size).fill(0);
                });
            }
        },
        {
            key: "clone",
            value: function clone(board) {
                return board.map(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row);
                });
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.clone(this.board);
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = "playing";
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = this.createEmptyBoard();
                this.score = 0;
                this.status = "idle";
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var empty = [];
                for(var row = 0; row < this.size; row++){
                    for(var col = 0; col < this.size; col++)if (this.board[row][col] === 0) empty.push([
                        row,
                        col
                    ]);
                }
                if (empty.length === 0) return;
                var _empty_Math_floor = (0, $efec029548ccee7f$export$71511d61b312f219)(empty[Math.floor(Math.random() * empty.length)], 2), i = _empty_Math_floor[0], j = _empty_Math_floor[1];
                this.board[i][j] = Math.random() < 0.9 ? 2 : 4;
            }
        },
        {
            key: "moveLeft",
            value: function moveLeft() {
                return this.move(function(row) {
                    return row;
                });
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                return this.move(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                this.transpose();
                var moved = this.move(function(row) {
                    return row;
                });
                this.transpose();
                return moved;
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                this.transpose();
                var moved = this.move(function(row) {
                    return (0, $227c6742e0ff6f82$export$71511d61b312f219)(row).reverse();
                });
                this.transpose();
                return moved;
            }
        },
        {
            key: "move",
            value: function move(transform) {
                var _this = this, _loop = function(i) {
                    var originalRow = _this.board[i];
                    var row = transform((0, $227c6742e0ff6f82$export$71511d61b312f219)(originalRow));
                    var compressed = row.filter(function(value) {
                        return value !== 0;
                    });
                    for(var j = 0; j < compressed.length - 1; j += 1)if (compressed[j] === compressed[j + 1]) {
                        compressed[j] *= 2;
                        _this.score += compressed[j];
                        compressed[j + 1] = 0;
                    }
                    var newRow = compressed.filter(function(value) {
                        return value !== 0;
                    });
                    while(newRow.length < _this.size)newRow.push(0);
                    var finalRow = transform(newRow);
                    if (finalRow.some(function(value, index) {
                        return value !== originalRow[index];
                    })) moved = true;
                    _this.board[i] = finalRow;
                };
                if (this.status !== "playing") return false;
                var moved = false;
                for(var i = 0; i < this.size; i += 1)_loop(i);
                if (moved) {
                    this.addRandomTile();
                    this.updateStatus();
                }
                return moved;
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                this.board = this.board[0].map(function(_, i) {
                    return _this.board.map(function(row) {
                        return row[i];
                    });
                });
            }
        },
        {
            key: "updateStatus",
            value: function updateStatus() {
                if (this.board.flat().includes(2048)) {
                    this.status = "win";
                    return;
                }
                if (this.canMove()) return;
                this.status = "lose";
            }
        },
        {
            key: "canMove",
            value: function canMove() {
                for(var i = 0; i < this.size; i += 1)for(var j = 0; j < this.size; j += 1){
                    if (this.board[i][j] === 0) return true;
                    if (j < this.size - 1 && this.board[i][j] === this.board[i][j + 1]) return true;
                    if (i < this.size - 1 && this.board[i][j] === this.board[i + 1][j]) return true;
                }
                return false;
            }
        }
    ]);
    return Game;
}();


var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
var $197cd56b15c33885$var$cells = document.querySelectorAll(".field-cell");
var $197cd56b15c33885$var$scoreEl = document.querySelector(".game-score");
var $197cd56b15c33885$var$button = document.querySelector(".button");
var $197cd56b15c33885$var$msgStart = document.querySelector(".message-start");
var $197cd56b15c33885$var$msgWin = document.querySelector(".message-win");
var $197cd56b15c33885$var$msgLose = document.querySelector(".message-lose");
function $197cd56b15c33885$var$render() {
    var state = $197cd56b15c33885$var$game.getState().flat();
    $197cd56b15c33885$var$cells.forEach(function(cell, i) {
        var value = state[i];
        cell.textContent = value === 0 ? "" : value;
        cell.className = "field-cell";
        if (value) cell.classList.add("field-cell--".concat(value));
    });
    $197cd56b15c33885$var$scoreEl.textContent = $197cd56b15c33885$var$game.getScore();
    $197cd56b15c33885$var$updateMessages();
}
function $197cd56b15c33885$var$updateMessages() {
    var gameStatus = $197cd56b15c33885$var$game.getStatus();
    $197cd56b15c33885$var$msgStart.classList.add("hidden");
    $197cd56b15c33885$var$msgWin.classList.add("hidden");
    $197cd56b15c33885$var$msgLose.classList.add("hidden");
    if (gameStatus === "idle") $197cd56b15c33885$var$msgStart.classList.remove("hidden");
    if (gameStatus === "win") $197cd56b15c33885$var$msgWin.classList.remove("hidden");
    if (gameStatus === "lose") $197cd56b15c33885$var$msgLose.classList.remove("hidden");
}
$197cd56b15c33885$var$button.addEventListener("click", function() {
    if ($197cd56b15c33885$var$game.getStatus() === "idle") {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$button.textContent = "Restart";
        $197cd56b15c33885$var$button.classList.remove("start");
        $197cd56b15c33885$var$button.classList.add("restart");
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$button.textContent = "Start";
        $197cd56b15c33885$var$button.classList.remove("restart");
        $197cd56b15c33885$var$button.classList.add("start");
    }
    $197cd56b15c33885$var$render();
});
document.addEventListener("keydown", function(e) {
    var moved = false;
    switch(e.key){
        case "ArrowLeft":
            moved = $197cd56b15c33885$var$game.moveLeft();
            break;
        case "ArrowRight":
            moved = $197cd56b15c33885$var$game.moveRight();
            break;
        case "ArrowUp":
            moved = $197cd56b15c33885$var$game.moveUp();
            break;
        case "ArrowDown":
            moved = $197cd56b15c33885$var$game.moveDown();
            break;
    }
    if (moved) $197cd56b15c33885$var$render();
});
$197cd56b15c33885$var$render();

})();
//# sourceMappingURL=index.6b2ae194.js.map
